import { GenericResource, IHttpAgent } from '@sparelabs/http-client-utils'
import {
  AuthorizationRoleStatus,
  IAuthorizationRoleListQueryParams,
  IAuthorizationRolePatchBody,
  IAuthorizationRolePostBody,
  IAuthorizationRoleResponse,
  Resources,
} from '../types'

export class AuthorizationRoleResource extends GenericResource<
  IAuthorizationRoleResponse,
  IAuthorizationRoleListQueryParams,
  IAuthorizationRolePatchBody,
  IAuthorizationRolePostBody
> {
  constructor(agent: IHttpAgent) {
    super(Resources.AuthorizationRole, agent)
  }

  public get = this.buildGet()
  public list = this.buildList()
  public post = this.buildPost()
  public patch = this.buildPatch()

  public async createDefaultRoles(): Promise<void> {
    return this.agent.post(`${this.resource}/createDefaultRoles`)
  }

  public async updatePermissionSets(groupId: string, permissionSetIds: string[]): Promise<void> {
    await this.agent.put(`${Resources.AuthorizationRole}/${groupId}/permissionSets`, { permissionSetIds })
  }

  public async archive(id: string): Promise<void> {
    await this.agent.patch(`${this.resource}/${id}`, { status: AuthorizationRoleStatus.Archived })
  }

  public async unarchive(id: string): Promise<void> {
    await this.agent.patch(`${this.resource}/${id}`, { status: AuthorizationRoleStatus.Active })
  }
}
